export default "__VITE_ASSET__056c8860__"